<template>
    <b-badge
        @click="showDeliveries"
        class="bgc_aux_unknown float-right"
        :disabled="!editAllowed"
        ><h3>{{ giveEvents }}</h3>
    </b-badge>
</template>

<script>
import DateHelper from '../../models/DateHelper';
import { loadItem } from '../../models/DataHelper';
export default {
    name: 'PlanDeliveryButton',
    data() {
        return {
            numberDeliveriesToday: 0,
            numberDeliveriesWeek: 0,
            delList: [],
            interval: null,
            tijd: 1000 * 60 * 10
            
        };
    },
    components: {},
    model: {},
    props: {
        editAllowed: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        giveEvents() {
            return this.numberDeliveriesToday + ' / ' + this.numberDeliveriesWeek;
        }
    },
    methods: {
        showDeliveries() {
            this.$emit('show', this.delList);
        },
        async loadPlanDeliveries() {
            const week = DateHelper.determineVanTot(new Date(), 7);
            const selectionDataWeek = {
                from: DateHelper.localDateToUTC(week.van),
                until: DateHelper.localDateToUTC(week.tot)
            };
            const lijst = await loadItem(
                'salesorder/loadSalesOrderInfo',
                selectionDataWeek,
                this.$t
            );
            this.numberDeliveriesWeek = lijst.length;

            const today = DateHelper.determineVanTot();
            const selectionData = {
                from: DateHelper.localDateToUTC(today.van),
                until: DateHelper.localDateToUTC(today.tot)
            };
            this.delList = await loadItem(
                'salesorder/loadSalesOrderInfo',
                selectionData,
                this.$t
            );
            this.numberDeliveriesToday = this.delList.length;
        }
    },
    async mounted() {
        await this.loadPlanDeliveries();
    },
    async created() {
        await this.loadPlanDeliveries();
        this.interval = setInterval(() => this.loadPlanDeliveries(), this.tijd);
    }
};
</script>

<style scoped></style>
